import { useEffect, useState } from "react"

import { loadShortcuts, subscribeShortcuts } from "src/utils/shortcuts"

/* The current key bindings, re-rendering whoever uses them when the settings pop-up saves. */
const useShortcuts = () => {
  const [shortcuts, setShortcuts] = useState(loadShortcuts)
  useEffect(() => subscribeShortcuts(setShortcuts), [])
  return shortcuts
}

export default useShortcuts
